import type { ApiResponse } from '@farmfree/common/types/apiResponse'
import type { Contact } from '@farmfree/common/types/contact/contact'
import { getFirebaseDb } from '@/services/firebaseService'
import { doc, getDoc } from 'firebase/firestore'

export function createContactService() {
  return {
    // Firestore에서 연락처 데이터 조회
    async getContacts(adminUid: string): Promise<ApiResponse<Contact[]>> {
      try {
        const db = getFirebaseDb()
        const contactsDocRef = doc(db, 'v2_administrators', adminUid, 'contacts', 'all')

        const docSnapshot = await getDoc(contactsDocRef)

        if (!docSnapshot.exists()) {
          return {
            isSuccess: true,
            data: [],
            message: '연락처 문서가 존재하지 않습니다.',
          }
        }

        const data = docSnapshot.data()

        if (!data.contacts || !Array.isArray(data.contacts)) {
          console.warn('contacts 배열이 없거나 배열이 아님:', data)
          return {
            isSuccess: true,
            data: [],
            message: 'contacts 데이터가 올바르지 않습니다.',
          }
        }

        // Firestore 데이터 구조에 맞게 파싱
        const contacts: Contact[] = data.contacts
          .map((contactData: any, index: number) => {
            return {
              name: contactData.n || '',
              phone: contactData.p || '',
              groups: contactData.g || [],
            }
          })
          .filter((contact) => contact.name && contact.phone) // 이름과 전화번호가 모두 있는 것만 필터링

        return {
          isSuccess: true,
          data: contacts,
          message: `연락처 ${contacts.length}개를 성공적으로 로드했습니다.`,
        }
      } catch (error: any) {
        console.error('연락처 데이터 로드 실패:', error)
        return {
          isSuccess: false,
          data: [],
          message: error.message || '연락처 데이터를 가져오는데 실패했습니다.',
        }
      }
    },
  }
}
